import { HeadCell } from '../../../../ui-kit';
import { translate } from '../../../../utils';
import { DeductionList } from './types';

export const deductionListsHeadCells: HeadCell<DeductionList>[] = [
    { id: 'deductionDateUtc', label: translate('Deduction date') },
    { id: 'createdBy', label: translate('Created by') },
    { id: 'deductionReason', label: translate('Deduction reason') },
    { id: 'deductionListItemsCount', label: translate('Deducted items count'), align: 'right' },
    { id: 'deductionListItemsTotalCost', label: translate('Deducted items value'), align: 'right' },
];
